import { useState } from 'react'
import {
  REGISTER,
  REGISTRATION_COMPLETE,
  START_REGISTRATION,
} from '../constants/mfa.setup.steps'
import { registerWebAuthn } from '../utils/registerWebAuthn'

// `prepareRegistration` and `finishRegistration` are the consuming app's own
// API calls. They resolve to `undefined` when the app is already redirecting
// (e.g. an expired session), in which case the flow just stops.
export function useSetupMFAWebAuthn({
  isFromSettings = false,
  prepareRegistration,
  finishRegistration,
}) {
  const [state, setState] = useState({
    step: START_REGISTRATION,
    isFromSettings,
    isProcessing: false,
    errorCode: null,
    registrationData: null,
    credential: null,
  })

  const prepare = async () => {
    setState((s) => ({ ...s, isProcessing: true, errorCode: null }))
    try {
      const response = await prepareRegistration()
      if (!response) return
      const { web_authn_registration_data: registrationData } = response
      setState((s) => ({
        ...s,
        registrationData,
        step: REGISTER,
      }))
      const credential = await registerWebAuthn({ registrationData })
      setState((s) => ({
        ...s,
        isProcessing: false,
        credential,
      }))
    } catch (error) {
      setState((s) => ({ ...s, isProcessing: false, errorCode: error.message }))
    }
  }

  const finish = async ({ registrationData, credential }) => {
    setState((s) => ({ ...s, isProcessing: true, errorCode: null }))
    try {
      await finishRegistration({
        requestId: registrationData?.requestId,
        credential,
      })
      setState((s) => ({
        ...s,
        isProcessing: false,
        step: REGISTRATION_COMPLETE,
      }))
      return true
    } catch (error) {
      setState((s) => ({ ...s, isProcessing: false, errorCode: error.message }))
      return false
    }
  }

  return { ...state, prepare, finish }
}
